module.exports = __webpack_public_path__ + "static/media/03.721fa3d1.png";